const apiUrl = {
  API_URL: process.env.REACT_APP_API_ENDPOINT,
  PROCTORING_API_URL: process.env.REACT_APP_PROCTORING_API_ENDPOINT
};
export default apiUrl;
